import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTriggerSectionIsViewedGaEvent } from 'core/hooks/useTriggerSectionIsViewedGaEvent';
import { fetchPlacements } from 'core/actions/ocapi';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import MarketingMotto from 'core/modules/Partials/MarketingMotto/MarketingMotto';
import List from 'core/modules/Partials/List/List';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';

import { selectSiteUrl } from 'core/selectors/app';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import FeaturedDeal from 'core/modules/FeaturedDeals/components/FeaturedDeal/FeaturedDeal';

import { triggerPersonalizedTopOffersIsViewed } from './actions';

import {
  selectPersonalizedTopOffersConfig, selectPersonalizedTopOffersIsLoading,
  selectPersonalizedTopOffersIsLoaded, selectPersonalizedTopOffersPlacementsToDisplay,
} from './selectors';

import './PersonalizedTopOffers.scss';

function PersonalizedTopOffers() {
  const dispatch = useDispatch();
  const personalizedTopOffersRef = useRef();
  const siteUrl = useSelector(selectSiteUrl);
  const config = useSelector(selectPersonalizedTopOffersConfig);
  const isLoading = useSelector(selectPersonalizedTopOffersIsLoading);
  const isLoaded = useSelector(selectPersonalizedTopOffersIsLoaded);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const dealsToDisplay = useSelector(selectPersonalizedTopOffersPlacementsToDisplay);

  const {
    viewAllLinkText, sectionTitle, getMotto, carousel,
  } = config;
  const motto = getMotto();

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      const { api: { params, options } } = config;
      dispatch(fetchPlacements({ ...params }, options));
    }
  }, []);

  const dispatchTriggerSectionIsViewed = () => dispatch(triggerPersonalizedTopOffersIsViewed());
  useTriggerSectionIsViewedGaEvent(personalizedTopOffersRef, dispatchTriggerSectionIsViewed);

  if (dealsToDisplay.length === 0) {
    return null;
  }

  return (
    <div className="mn_personalizedTopOffers" ref={personalizedTopOffersRef}>
      <ContentWrap mobile tablet l xl>
        <MarketingMotto motto={motto} />
        <SectionTitle title={sectionTitle}>
          {!isMobileMQ && <a className="mn_viewAllLink" href={`${siteUrl}/sp____.htm`}>{viewAllLinkText}</a>}
        </SectionTitle>
        <div className="mn_personalizedTopOffersContainer">
          <List options={carousel} shouldUseCarousel={!isMobileMQ}>
            {dealsToDisplay.map(offer => (
              <FeaturedDeal offer={offer} key={`${offer.id}`} config={config} />
            ))}
          </List>
        </div>
        {isMobileMQ &&
          <a className="mn_button mn_secondaryButton" href={`${siteUrl}/sp____.htm`}>
            {viewAllLinkText}
          </a>
        }
      </ContentWrap>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><PersonalizedTopOffers {...props} /></ComponentErrorBoundary>;
